module.exports = __webpack_public_path__ + "img/ae14237a134bdacb801cf0b4bb46778b.png";